<div *flashMessage="let notification of bubbleNotification$; options: {activeTime: 10 * 60 * 1000}"
     class="m-app-updates_bubble-notification">

    {{notification.message | l10n}}
    @if (notification.showReloadBtn) {
        <button
            class="m-app-updates_bubble-notification-btn"
            (click)="onReloadClick($event)">
            {{'components.mobile.app-updates.reload_button' | l10n}}
        </button>
    }
    @if (notification.showRetryBtn) {
        <button
            class="m-app-updates_bubble-notification-btn"
            (click)="onRetryClick($event, notification.retryCallback)">
            {{'components.mobile.app-updates.retry_button' | l10n}}
        </button>
    }
</div>
